export default __webpack_public_path__ + "static/media/shakesgen.571c5b77.png";